export type VariantToastType = "info" | "warning" | "success" | "error";

export enum ToastType {
  info = "info",
  warning = "warning",
  success = "success",
  error = "error"
}
